(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kd-section-best-selling"] && !Shopify.designMode) return;
  try {
    


slick_slider_seen();

$(window).resize(function() {
  slick_slider_seen();
});

$(window).on('resize', function() {
  slick_slider_seen(); 
});
  
$(window).on('orientationchange', function() {
  slick_slider_seen(); 
});

function slick_slider_seen() {
    var wrapper_seen = $(".kd-section--best-selling-products");
    $(".kd-section--best-selling-products").not('.slick-initialized').slick({
        mobileFirst: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
              breakpoint: 1024,
              settings: "unslick"
          }
        ]
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-section-blog-content-alt"] && !Shopify.designMode) return;
  try {
    

$(document).on('ready', function() {    
    //Create Table of Contents
    $("#kd-toc").toc({content: "div.kd-body__article-content", headings: "h2"});

    //Hide Table of Contents div if list is empty
    if ($("#kd-toc li").length == 0) {
        $(".kd-article-content__toc").addClass("kd-hidden");
    }
    
    //Toggle Table of Contents
    $(".kd-article-content__toc-heading").on("click", function() {
        $(this).toggleClass("active");
        $(this).next().slideToggle(200);
    });

    //Display Table of Contents on page load
    $(".kd-article-content__toc-heading").toggleClass("active");
    $(".kd-article-content__toc-heading").next().slideToggle(200);

    //Hide Table of Content if mobile
    var width = $(window).width();
    if (width <= 1024) {
        $(".kd-article-content__toc-heading").removeClass("active");
        $(".kd-article-content__toc-heading").next().hide();
    } 
    var scrollPosition = $(window).scrollTop();

    

    //Hide empty li
    $("#kd-toc li a").each(function() {
        if($.trim($(this).html()) == '') {
            $(this).parent('li').hide();
        }
    });

    // cache the navigation links 
    var $navigationLinks = $('#kd-toc > li > a');
    // cache (in reversed order) the sections
    var $sections = $($(".kd-section--blog-content__body h2").get().reverse());

    // map each section id to their corresponding navigation link
    var sectionIdTonavigationLink = {};
    $sections.each(function() {
        var id = $(this).attr('id');
        sectionIdTonavigationLink[id] = $('#kd-toc > li > a[href*="#' + id + '"');

        if (width <= 1024) {
            sectionIdTonavigationLink[id].click(function() {
                $(".kd-article-content__toc-heading").removeClass("active");
                $(".kd-article-content__toc-heading").next().hide();
            });
        }
    });  
    
    // throttle function, enforces a minimum time interval
    function throttle(fn, interval) {
        var lastCall, timeoutId;
        return function () {
            var now = new Date().getTime();
            if (lastCall && now < (lastCall + interval) ) {
                // if we are inside the interval we wait
                clearTimeout(timeoutId);
                timeoutId = setTimeout(function () {
                    lastCall = now;
                    fn.call();
                }, interval - (now - lastCall) );
            } else {
                // otherwise, we directly call the function 
                lastCall = now;
                fn.call();
            }
        };
    }

    function highlightNavigation() {
        // get the current vertical position of the scroll bar
        var scrollPosition = $(window).scrollTop();

        // iterate the sections
        $sections.each(function() {
            var currentSection = $(this);
            
            // get the position of the section
            var sectionTop = currentSection.offset().top - 150;

            // if the user has scrolled over the top of the section  
            if (scrollPosition >= sectionTop) {
                // get the section id
                var id = currentSection.attr('id');
                // get the corresponding navigation link
                var $navigationLink = sectionIdTonavigationLink[id];
                // if the link is not active
                if (!$navigationLink.hasClass('active')) {
                    // remove .active class from all the links
                    $navigationLinks.removeClass('active');
                    // add .active class to the current link
                    $navigationLink.addClass('active');
                }
                // we have found our section, so we return false to exit the each loop
                return false;
            }
        });
    }

    // load initial highlight
    throttle(highlightNavigation,100);

    // on scroll highlight
    $(window).scroll( throttle(highlightNavigation,100) );
  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-section-blog-content"] && !Shopify.designMode) return;
  try {
    

$(document).on('ready', function() {    
    //Create Table of Contents
    $("#kd-toc").toc({content: "div.kd-body__article-content", headings: "h2,h3"});

    //Hide Table of Contents div if list is empty
    if ($("#kd-toc li").length == 0) {
        $(".kd-article-content__toc").addClass("kd-hidden");
    }
    
    //Toggle Table of Contents
    $(".kd-article-content__toc-heading").on("click", function() {
        $(this).toggleClass("active");
        $(this).next().slideToggle(200);
    });

    //Display Table of Contents on page load
    $(".kd-article-content__toc-heading").toggleClass("active");
    $(".kd-article-content__toc-heading").next().slideToggle(200);

    //Hide empty li
    $("#kd-toc li a").each(function() {
        if($.trim($(this).html()) == '') {
            $(this).parent('li').hide();
        }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-section-faq"] && !Shopify.designMode) return;
  try {
    
$(document).on('ready', function() {

  $(".kd-primary-accordion:first").toggleClass("active kd-border-top");
  $(".kd-primary-accordion:first").next().slideToggle(200);

  $(".kd-primary-accordion").on("click", function() {
    $(this).toggleClass("active");
    $(this).next().slideToggle(200);
  });

  $(".kd-secondary-accordion").on("click", function() {
    $(this).toggleClass("active");
    $(this).next().slideToggle(200);
  });

  var linkArray = [];
  $('.kd-button.kd-button--border').each(function () {
      linkArray.push(this.id.split("kd-").join(""));
  });

  linkArray;
  
  $.each(linkArray, function (index, value) {
    $("#kd-"+value).on("click", function() {
      $('.kd-primary-panel').hide();
      $('.kd-primary-accordion').removeClass("active");
      $("#"+value+" .kd-primary-accordion").toggleClass("active");
      $("#"+value+" .kd-primary-accordion").next().slideToggle(200);
    });
  });
  
  $('#kd-faq-search').on('keyup', function () {
    console.log($(this).val().toLowerCase());

    var faq_term = $("#kd-faq-search").val().toLowerCase();

    $(".kd-section--faq").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(faq_term) > -1);
    });

    $(".kd-secondary-accordion-container").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(faq_term) > -1);
    });

    if( faq_term != '' ){
      $(".kd-section--faq").find('.kd-primary-accordion').addClass('active');
      $(".kd-section--faq").find('.kd-primary-panel').addClass('active');
    } else {
      $(".kd-section--faq").find('.kd-primary-accordion').removeClass('active');
      $(".kd-section--faq").find('.kd-primary-panel').removeClass('active');
    }

    //$(".kd-section--faq .kd-primary-accordion").toggleClass("active");
    //$(".kd-section--faq .kd-primary-accordion").next().slideToggle(200);
  });
    
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kd-section-icon-text-description"] && !Shopify.designMode) return;
  try {
    
  slick_slider_seen();

  $(window).resize(function() {
    slick_slider_seen();
  });

  $(window).on('resize', function() {
    slick_slider_seen();
  });

  $(window).on('orientationchange', function() {
    slick_slider_seen();
  });

  function slick_slider_seen() {
      var wrapper_seen = $(".kd-section--icon-text-description__boxes");
      $(".kd-section--icon-text-description__boxes").not('.slick-initialized').slick({
          mobileFirst: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          responsive: [{
              breakpoint: 767,
              settings: "unslick"
          }]
      });
  }

  } catch(e) { console.error(e); }
})();
})();
